// extracted by mini-css-extract-plugin
export default {"polaroid":"NewPolaroid_polaroid__+VF98","NamePrice":"NewPolaroid_NamePrice__-Odfg","Price":"NewPolaroid_Price__4lYLv"};